import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as periodosService from '../../services/periodos/periodosService';
import {
  buildPeriodoCursadaValidationError,
  classifyPeriodosError,
  getPeriodoCursadaLabel,
  PERIODO_CURSADA_OPTIONS,
  toUpdatePeriodoCursadaPayload,
  validateInscriptionDates,
  validateInscriptionInsidePeriod,
  validatePeriodDates,
  validatePeriodoCursadaFormUpdate,
} from '../../services/periodos/periodosDto';
import { findSelectOptionByValue } from '../../services/selectOptions';
import { LookupAnioAcademicos } from '../AnioAcademico/LookupAnioAcademicos';
import { parseDate, displayDate, todayCalendarDate } from '../../services/dates/dateService';
import { CalendarDatePicker } from '../common/CalendarDatePicker';
import Select from '../common/AppSelect';

export class UpdatePeriodoCursada extends Component {
  static displayName = UpdatePeriodoCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingData: true,
      descripcion: '',
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      showLookupAnios: false,
      startDate: todayCalendarDate(),
      endDate: todayCalendarDate(),
      startInscriptionDate: todayCalendarDate(),
      endInscriptionDate: todayCalendarDate(),
      periodoOption: null,
      anio: { anioAcademicoCod: 0, anioAcademicoDescripcion: '' },
      id: this.props.match.params.id,
      details: this.props.match.params.details,
    };
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWPeriodoCursada');
    if (canAccess) {
      await this.populateData();
    }
  }

  handleConfirmButton = () => {
    const datesOk = validatePeriodDates(this.state.startDate, this.state.endDate);
    const inscriptionDatesOk = validateInscriptionDates(
      this.state.startInscriptionDate,
      this.state.endInscriptionDate
    );
    const isOkToSave = validatePeriodoCursadaFormUpdate({
      descripcion: this.state.descripcion,
      anioPresent: this.state.anio != null,
      anioDescripcion: this.state.anio?.anioAcademicoDescripcion,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      startInscriptionDate: this.state.startInscriptionDate,
      endInscriptionDate: this.state.endInscriptionDate,
    });
    const inscriptionDateInsidePeriodDates = validateInscriptionInsidePeriod({
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      startInscriptionDate: this.state.startInscriptionDate,
      endInscriptionDate: this.state.endInscriptionDate,
    });
    const errorMessage = buildPeriodoCursadaValidationError({
      formValid: isOkToSave,
      datesOk,
      inscriptionDatesOk,
      inscriptionInsidePeriod: inscriptionDateInsidePeriodDates,
    });

    if (isOkToSave && datesOk && inscriptionDatesOk && inscriptionDateInsidePeriodDates) {
      this.saveStudent();
      return;
    }

    this.setState({ showErrorMessage: true, errorMessage });
  };

  async populateData() {
    this.setState({ loadingData: true });
    try {
      const returnModel = await periodosService.getPeriodoCursada(this.state.id);
      const descripcion = returnModel.periodoCursadaDescripcion.trim();
      this.setState({
        loadingData: false,
        errorMessage: '',
        showErrorMessage: false,
        anio: {
          anioAcademicoCod: returnModel.anioAcademicoCod,
          anioAcademicoDescripcion: returnModel.anioAcademicoDescripcion,
        },
        descripcion,
        periodoOption: findSelectOptionByValue(PERIODO_CURSADA_OPTIONS, descripcion),
        startDate: parseDate(returnModel.periodoCursadaFechaInicio),
        endDate: parseDate(returnModel.periodoCursadaFechaFin),
        startInscriptionDate: parseDate(returnModel.periodoCursadaInicioInscripcio),
        endInscriptionDate: parseDate(returnModel.periodoCursadaFinInscripcion),
      });
    } catch (error) {
      const outcome = classifyPeriodosError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loadingData: false,
        errorMessage: outcome.message,
      });
    }
  }

  handleEndInscripcionDate = (date) => {
    this.setState({ endInscriptionDate: date, showErrorMessage: false, errorMessage: '' });
  };

  handleStartInscriptionDate = (date) => {
    this.setState({ startInscriptionDate: date, showErrorMessage: false, errorMessage: '' });
  };

  handleShowAniosLookup = () => {
    this.setState({ showLookupAnios: true });
  };

  handleStartDate = (date) => {
    this.setState({ startDate: date, showErrorMessage: false, errorMessage: '' });
  };

  handleEndDate = (date) => {
    this.setState({ endDate: date, showErrorMessage: false, errorMessage: '' });
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handlePeriodoChange = (option) => {
    const descripcion = option?.value ?? '';
    this.setState({
      descripcion,
      periodoOption: option,
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleSelectAnioItem = (e) => {
    const anioProperties = e.split('%');
    this.setState({
      showLookupAnios: false,
      showErrorMessage: false,
      errorMessage: '',
      anio: {
        anioAcademicoCod: anioProperties[0],
        anioAcademicoDescripcion: anioProperties[1],
      },
    });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-pcr" />;
    }

    const isDetail = this.state.details !== '0';
    const title = isDetail ? 'Detalle de Período de Cursada' : 'Modificar Período de Cursada';
    const { loading, loadingData } = this.state;
    const isBusy = loading || loadingData;

    return (
      <div className="md-page md-update-pcr">
        <Link className="md-page__back-link" to="/md-pcr">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">{title}</h1>
        </div>
        <p className="md-page__subtitle">
          {isDetail
            ? 'Consulte los datos registrados del período de cursada.'
            : 'Actualice los datos del período y confirme para guardar los cambios.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {this.state.errorMessage && !this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loadingData ? (
            <div className="md-page__status">Cargando datos...</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Período de cursada</span>
            {isDetail ? (
              <div className="md-page__field-readonly">
                {getPeriodoCursadaLabel(this.state.descripcion) || '\u00a0'}
              </div>
            ) : (
              <Select
                className="md-page__field-select"
                value={this.state.periodoOption}
                options={PERIODO_CURSADA_OPTIONS}
                placeholder="Seleccioná el período"
                onChange={this.handlePeriodoChange}
                disabled={isBusy}
              />
            )}
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Año académico</span>
            {!isDetail ? (
              <div className="md-page__picker-block">
                {!isBusy ? (
                  <button type="button" className="md-page__picker-link" onClick={this.handleShowAniosLookup}>
                    Seleccionar año académico
                  </button>
                ) : null}
                <div className="md-page__field-readonly">
                  {this.state.anio.anioAcademicoDescripcion || '\u00a0'}
                </div>
              </div>
            ) : (
              <div className="md-page__field-readonly">
                {this.state.anio.anioAcademicoDescripcion || '\u00a0'}
              </div>
            )}
          </div>

          <section className="md-page__form-section">
            <p className="md-page__form-section-title">Fechas del período</p>
            <div className="md-page__form-date-row">
              <div className="md-page__field">
                <span className="md-page__field-label">Fecha de inicio</span>
                {isDetail ? (
                  <div className="md-page__field-readonly">{displayDate(this.state.startDate) || '\u00a0'}</div>
                ) : (
                  <CalendarDatePicker
                    className="md-page__field-input"
                    selected={this.state.startDate}
                    onChange={this.handleStartDate}
                    disabled={isBusy}
                  />
                )}
              </div>
              <div className="md-page__field">
                <span className="md-page__field-label">Fecha de fin</span>
                {isDetail ? (
                  <div className="md-page__field-readonly">{displayDate(this.state.endDate) || '\u00a0'}</div>
                ) : (
                  <CalendarDatePicker
                    className="md-page__field-input"
                    selected={this.state.endDate}
                    onChange={this.handleEndDate}
                    disabled={isBusy}
                  />
                )}
              </div>
            </div>
          </section>

          <section className="md-page__form-section">
            <p className="md-page__form-section-title">Fechas de inscripción</p>
            <div className="md-page__form-date-row">
              <div className="md-page__field">
                <span className="md-page__field-label">Inicio de inscripción</span>
                {isDetail ? (
                  <div className="md-page__field-readonly">
                    {displayDate(this.state.startInscriptionDate) || '\u00a0'}
                  </div>
                ) : (
                  <CalendarDatePicker
                    className="md-page__field-input"
                    selected={this.state.startInscriptionDate}
                    onChange={this.handleStartInscriptionDate}
                    disabled={isBusy}
                  />
                )}
              </div>
              <div className="md-page__field">
                <span className="md-page__field-label">Fin de inscripción</span>
                {isDetail ? (
                  <div className="md-page__field-readonly">
                    {displayDate(this.state.endInscriptionDate) || '\u00a0'}
                  </div>
                ) : (
                  <CalendarDatePicker
                    className="md-page__field-input"
                    selected={this.state.endInscriptionDate}
                    onChange={this.handleEndInscripcionDate}
                    disabled={isBusy}
                  />
                )}
              </div>
            </div>
          </section>

          {!isDetail ? (
            <div className="md-page__form-actions">
              <button
                type="button"
                className="md-page__form-btn md-page__form-btn--primary"
                onClick={this.handleConfirmButton}
                disabled={isBusy}
              >
                Guardar cambios
              </button>
            </div>
          ) : null}
        </div>

        {this.state.showLookupAnios ? (
          <LookupAnioAcademicos selectItem={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
        ) : null}
      </div>
    );
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await periodosService.savePeriodoCursada(
        toUpdatePeriodoCursadaPayload({
          id: parseInt(this.state.id, 10),
          descripcion: this.state.descripcion,
          fechaInicio: this.state.startDate,
          fechaFin: this.state.endDate,
          inicioInscripcion: this.state.startInscriptionDate,
          finInscripcion: this.state.endInscriptionDate,
          anioAcademicoCod: parseInt(this.state.anio.anioAcademicoCod, 10),
        })
      );
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyPeriodosError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        showErrorMessage: true,
        errorMessage: outcome.message,
      });
    }
  }
}
